/**
 * @generated SignedSource<<76fddc4ba82ee6d03876a3314cc9ca9f>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NftPdpBidModalContext_nftItem$data = {
  readonly balanceForUser?: {
    readonly balance: number | null;
    readonly ownerAddress: {
      readonly address: string | null;
    } | null;
  } | null;
  readonly contract: {
    readonly address: string | null;
  } | null;
  readonly creatorAddress: {
    readonly publicProfile: {
      readonly profileName: string | null;
    } | null;
  } | null;
  readonly edition: number | null;
  readonly etherRates: ReadonlyArray<{
    readonly " $fragmentSpreads": FragmentRefs<"useEtherConversion_etherRates">;
  } | null> | null;
  readonly metadata: {
    readonly name?: string | null;
  } | null;
  readonly mostRecentAuction: {
    readonly auctionId: number | null;
    readonly endedConversionRates: {
      readonly rates: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"useEtherConversion_etherRates">;
      } | null> | null;
    } | null;
    readonly " $fragmentSpreads": FragmentRefs<"useLatestAuctionInfo_nftAuction">;
  } | null;
  readonly serviceId: string | null;
  readonly tokenId: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"useLatestUserInfo_nftItem">;
  readonly " $fragmentType": "NftPdpBidModalContext_nftItem";
};
export type NftPdpBidModalContext_nftItem$key = {
  readonly " $data"?: NftPdpBidModalContext_nftItem$data;
  readonly " $fragmentSpreads": FragmentRefs<"NftPdpBidModalContext_nftItem">;
};

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "address",
    "storageKey": null
  }
],
v1 = [
  {
    "args": null,
    "kind": "FragmentSpread",
    "name": "useEtherConversion_etherRates"
  }
];
return {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "fetchUser"
    },
    {
      "kind": "RootArgument",
      "name": "userId"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "NftPdpBidModalContext_nftItem",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "useLatestUserInfo_nftItem"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "tokenId",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftTokenContract",
      "kind": "LinkedField",
      "name": "contract",
      "plural": false,
      "selections": (v0/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "NftAuction",
      "kind": "LinkedField",
      "name": "mostRecentAuction",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useLatestAuctionInfo_nftAuction"
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "auctionId",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "NftConversionRateEvent",
          "kind": "LinkedField",
          "name": "endedConversionRates",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "EtherRates",
              "kind": "LinkedField",
              "name": "rates",
              "plural": true,
              "selections": (v1/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "condition": "fetchUser",
      "kind": "Condition",
      "passingValue": true,
      "selections": [
        {
          "alias": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "NftItemBalance",
          "kind": "LinkedField",
          "name": "balanceForUser",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "balance",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "EthereumAddressType",
              "kind": "LinkedField",
              "name": "ownerAddress",
              "plural": false,
              "selections": (v0/*: any*/),
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ]
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EtherRates",
      "kind": "LinkedField",
      "name": "etherRates",
      "plural": true,
      "selections": (v1/*: any*/),
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "metadata",
      "plural": false,
      "selections": [
        {
          "kind": "InlineFragment",
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "name",
              "storageKey": null
            }
          ],
          "type": "NftDigitalArtMetadata",
          "abstractKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "EthereumAddressType",
      "kind": "LinkedField",
      "name": "creatorAddress",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "PublicProfile",
          "kind": "LinkedField",
          "name": "publicProfile",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "profileName",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "edition",
      "storageKey": null
    }
  ],
  "type": "NftItem",
  "abstractKey": null
};
})();

(node as any).hash = "53ed31bc8bec99df3d1aca2ae8fe0853";

export default node;
